import DeepDiff from 'deep-diff'
import SystemMessageService from './systemMessageService'
import StoreUtil from '@/store/utils'

const tag = 'systemmessage'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: (state) => state.snapshots,
  baseSnapshot: (state) => state.snapshots[state.baseIndex],
  currentSnapshot: (state) => state.snapshots[state.currentIndex],
  snapshotDiff: (state) => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  async getStoreItem({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const data = await SystemMessageService.getMessage(id)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    if (entity) {
      StoreUtil.setStorage(entity.systemMessageId, tag, entity)
      commit('saveInitialSnapshots', entity)
    }
  },
  async addStoreItem({ commit }) {
    const entity = await SystemMessageService.getNewEntity()
    entity.isNew = true
    StoreUtil.setStorage(entity.systemMessageId, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  clearSnapshots({ commit }, id) {
    if (id) {
      StoreUtil.removeStorage(id, tag)
    }
    commit('clearSnapshots')
  },
  saveInitialSnapshots({ commit }, entity) {
    commit('saveInitialSnapshots', entity)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  }
}

const mutations = {
  clearSnapshots(state) {
    state.baseIndex = 0
    state.currentIndex = 0
    state.snapshots = []
  },
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots[0] = entity
    state.snapshots[1] = entity
    state.baseIndex = 0
    state.currentIndex = 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

